<input
  #file
  type="file"
  accept="{{ acceptedFiles }}"
  class="custom-file-input button-cursor"
  [ngClass]="{ 'custom-file-label': showIcon }"
  (change)="uploadFile(file.files)"
/>
<i *ngIf="showIcon" class="{{ attachmentIcon }}" (click)="file.click()"></i>
<label *ngIf="!showIcon" class="custom-file-label" (click)="file.click()">
  {{ title }}
</label>

<div class="progress upload" *ngIf="progress > 0 && progress < 100">
  <div class="progress-bar" [style.width]="progress + '%'">{{ progress }}%</div>
</div>
